import { render, staticRenderFns } from "./ComplianceSingleElementScore.vue?vue&type=template&id=937e42ae&"
import script from "./ComplianceSingleElementScore.vue?vue&type=script&lang=ts&"
export * from "./ComplianceSingleElementScore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports